import React from 'react';
import { Link } from 'react-router-dom';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import BlockIcon from '@mui/icons-material/Block';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import ErrorPageLayout from './ErrorPageLayout';

const Forbidden: React.FC = () => {
  return (
    <ErrorPageLayout
      icon={<BlockIcon sx={{ fontSize: 44 }} />}
      color="error"
      code="403"
      title="アクセス権限がありません"
    >
      <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.8 }}>
        このページにアクセスする権限がありません。
        <br />
        管理者にお問い合わせください。
      </Typography>
      <Stack direction="row" spacing={1.5} sx={{ mt: 1 }}>
        <Button
          variant="contained"
          component={Link}
          to="/"
          startIcon={<ArrowBackIcon />}
          sx={{
            px: 3,
            py: 1,
            borderRadius: 2,
            textTransform: 'none',
            fontWeight: 600,
            boxShadow: 'none',
            '&:hover': { boxShadow: 'none' },
          }}
        >
          TOPへ戻る
        </Button>
      </Stack>
    </ErrorPageLayout>
  );
};

export default Forbidden;
